import React from 'react';
import './App.css';
import './css/Responsive.css';

// import AttendeeRoutes from './AppRoutes/AttendeeRoutes';
import AdminRoutes from './AppRoutes/AdminRoutes';
import ExhibitorRoutes from './AppRoutes/ExhibitorRoutes'
import EventappRoutes from './AppRoutes/EventappRoutes'
import LoginRoutes from './AppRoutes/LoginRoutes'
import ExhibitorPortalEvent from './AppRoutes/ExhibitorPortalEvent'
import EPortalSubscriptions from './AppRoutes/EPortalSubscriptions' 
import AttendeeRoutes from './AppRoutes/AttendeeRoutes' 
import GuestRoutes from './AppRoutes/GuestRoutes'
import ScrollToTop from "./ScrollTop";

function App() {
  return ( 
    <React.Fragment>
      <ScrollToTop>
      <AdminRoutes/>
      <ExhibitorRoutes/>
      <EventappRoutes/>
      <LoginRoutes/>
      <ExhibitorPortalEvent/>
      <EPortalSubscriptions/>
      <AttendeeRoutes/>
      <GuestRoutes/>
      </ScrollToTop>
    </React.Fragment>      
     
   
      
  );
}

export default App;
